import {createFeatureAppDefinition} from '@smart/feature-app/react';
import * as React from 'react';
import {App} from './components/app';
import {ErrorInRoot} from './components/error-in-root';

const featureAppDefinition = createFeatureAppDefinition({
  App: ({done}) => <App done={done} />,
  fallback: <ErrorInRoot />,
});

export default featureAppDefinition;
